<template>
  <CardLayout @onHrTree="onHrTree">
    <div class="card-body">

      <div class="search-wrap">
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-loading="loading" class="chat-table" :data="tableData">
          <el-table-column prop="id" label="ID" align="left" width="50"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="phone" label="电话" align="center"></el-table-column>
          <el-table-column prop="job" label="职位" align="center"></el-table-column>
          <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
          <el-table-column prop="company" label="公司" align="center"></el-table-column>
          <el-table-column prop="card_style" label="主题" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
      </div>

      <!-- 修改窗口 -->
      <el-dialog title="卡片编辑" :visible.sync="dialogVisible" width="600px">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="名字" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="phone">
            <el-input v-model="form.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="工作" prop="job">
            <el-input v-model="form.job" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="tel">
            <el-input v-model="form.tel" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司" prop="company">
            <el-input v-model="form.company" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="form.address" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="卡片背景图" prop="background">
            <el-input v-model="form.background" autocomplete="off"></el-input>
            <el-select
              v-model="bgId"
              filterable
              remote
              reserve-keyword
              :remote-method="getCardBg"
              placeholder="搜索卡片背景">
              <el-option
                v-for="item in card_bg_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字体颜色" prop="font_color">
            <!--        <el-input v-model="form.font_color" autocomplete="off"></el-input>-->
            <el-color-picker v-model="form.font_color"></el-color-picker>
          </el-form-item>

          <el-form-item label="主题" prop="card_style">
            <el-select
              v-model="form.card_style"
              filterable
              remote
              reserve-keyword
              :remote-method="getCardStyle"
              placeholder="主题">
              <el-option label="系统自带主题" value=""></el-option>
              <el-option
                v-for="item in card_style_list"
                :key="item.id"
                :label="item.name"
                :value="(item.id*1)">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </CardLayout>

</template>

<script>

  import { Loading } from 'element-ui';
  import {Card, User} from './common.js'
  import xhHelp from "./xhHelp";
  import CardLayout from "./components/CardLayout";

export default {
  name: "CardCard",
  components: {CardLayout},
  data () {
    return {
      keyword: '',
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      formLoading: false,
      form: {
        id:'',
        user_id:'',
        card_style:'',
        name:'',
        phone:'',
        job:'',
        email:'',
        tel:'',
        company:'',
        address:'',
        background:'',
        font_color:'',
        create_time:'',
        update_time:'',

      },
      card_style_list:[],
      card_bg_list:[],
      bgId:'',
      department_id:""
    }
  },
  created() {
    this.getList()
  },
  methods: {
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      Card.getList({
        keyword: this.keyword,
        department_id:this.department_id,
        page: this.page,
        page_size: this.pageSize
      }, res => {
        if(res.code == 0) {
          this.total = res.data.total
          this.tableData = res.data.data
        }
      })
    },
    getCardStyle(name=''){
      var that=this;
      xhHelp.get("CardStyle/getList",{keyword:name,page:1},ret=>{
        that.card_style_list=ret.data.data
      })
    },
    getCardBg(name=''){
      var that=this;
      xhHelp.get("CardBackground/getList",{keyword:name,page:1},ret=>{
        that.card_bg_list=ret.data.data
      })
    },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    getFormData(data) {
      return Object.assign({
        id:'',
        user_id:'',
        card_style:'',
        name:'',
        phone:'',
        job:'',
        email:'',
        tel:'',
        company:'',
        address:'',
        background:'',
        font_color:'',
        create_time:'',
        update_time:'',
      }, data)
    },
    edit(item=null) {
      if(item){
        let data = {}
        for(let k in this.form) {
          data[k] = item[k]
        }
        this.form = data
      }else {
        this.form=this.getFormData({})
      }
      this.getCardStyle('')
      this.getCardBg('')
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          xhHelp.post("card/update",data,res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })

        } else {
          return false;
        }
      });
    },
    setFormItem(item){
      let data = Object.assign({}, item)
      xhHelp.post("card/update",data,res => {
        this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
        if(res.code == 0) {
          this.getList()
        }
      })
    },
    deleteUser(item) {
      const that = this;
      that.$confirm('此操作将删除该会员['+item.name+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        xhHelp.post("card/delete",{id:item.id},res => {
          that.$message({type: res.code? 'success': 'error', message: res.msg})
          if(res.code) {
            that.getList()
          }
        })
      })

    },
    onHrTree(e){
      const that=this;
      that.department_id=e.id;
      that.search();
    }
  },
  watch:{
    bgId(n){
      let card_bg=this.card_bg_list.find(ret=>{ return ret.id==n })
      if(card_bg){
        this.form.background=xhHelp.hostUrl(card_bg.path);
        this.form.font_color=card_bg.color;
      }

    }
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/Card.vue